<p-table 
    #table 
    [loading]="loading" 
    [value]="documenti" 
    responsiveLayout="stack" 
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm" 
    [paginator]="false" 
    [showCurrentPageReport]="true" 
    [rowHover]="true" 
    [globalFilterFields]="['nome', 'tipo']" 
    currentPageReportTemplate="{first} di {last} su {totalRecords} documenti" 
    [rows]="50" [rowsPerPageOptions]="[10, 20, 50, 75, 100, 125, 150]">            
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-3 w-full">
            <div class="lg:w-3/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca documento…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div> 
            <div class="lg:w-1/4 w-full table-toolbar-btns">
                <button class="flex-1 acc-btn" type="button" (click)="onZip()">                
                    <i class="bi bi-file-zip-fill"></i>
                    Scarica
                </button>
            </div>               
        </div>            
    </ng-template>
    <ng-template pTemplate="header">
        <tr>     
            <th class="w-1/12 text-center">File</th>                     
            <th pSortableColumn="nome" class="w-4/12">Nome <span class="inline-flex"><p-sortIcon field="nome" /></span></th>
            <th pSortableColumn="tipo" class="w-2/12">Tipo <span class="inline-flex"><p-sortIcon field="tipo" /></span></th>
            <th class="w-2/12 text-center">Note / Scadenza</th>
            <th class="w-2/12 text-center">Alert</th>
            <th class="w-1/12 text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-documento let-index="index">
        <tr>                
            <td class="text-center">
                <button type="button" class="flex justify-center w-full bg-transparent border-0 p-0 cursor-pointer" (click)="onOpenDocumento(documento.file)">
                    <ng-container *ngIf="(documento.file | type) == 'image'">
                        <img #img class="doc-thumb" [appAuthSrc]="documento.file" appAuthType="accreditamento" (error)="img.src= '../../../../../assets/images/logo.svg'; img.classList.add('p-2', 'object-contain'); img.classList.remove('object-cover')">
                    </ng-container>
                    <ng-container *ngIf="(documento.file | type) == 'pdf'">
                        <img #img_pdf class="doc-thumb" [appAuthSrc]="documento.preview" appAuthType="accreditamento" (error)="img_pdf.src = '../../../../../assets/images/logo_pdf.jpg'">
                    </ng-container>                    
                </button>
            </td>
            <td>
                <span class="p-column-title">Nome</span>
                <button type="button" class="cell-nome underline hover:no-underline bg-transparent border-0 p-0 cursor-pointer text-left" (click)="onOpenDocumento(documento.file)">{{documento.nome}}</button>
            </td>
            <td>
                <span class="p-column-title">Tipo</span>
                <span class="mini-pill">{{documento.tipo.replace('_', ' ')}}</span>
                @if (documento.id_personale) {
                    <span class="cell-meta">Personale: {{ documento.persona }}</span>
                }
                @if (documento.id_subappalto) {
                    <span class="cell-meta">Subappalto: {{ labelSubappalto(documento) }}</span>
                }
            </td>
            <td class="text-center">
                <span class="p-column-title">{{ isImpianto(documento) ? 'Note' : 'Scadenza' }}</span>
                @if (isImpianto(documento)) {
                    <input
                        type="text"
                        pInputText
                        class="w-full"
                        [ngModel]="documento.note || ''"
                        (ngModelChange)="onNotaDraft(documento, $event)"
                        [ngModelOptions]="{standalone: true}"
                        (blur)="onNotaBlur(documento)"
                        placeholder="Note…"
                    />
                } @else {
                    <p-calendar
                        [ngModel]="scadenzaDate(documento)"
                        (ngModelChange)="onScadenza($event, documento)"
                        [ngModelOptions]="{standalone: true}"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        [showClear]="true"
                        appendTo="body"
                        placeholder="dd/mm/aaaa"
                        [title]="isScaduto(documento) ? 'Documento scaduto' : 'Data scadenza'"
                        [styleClass]="'scadenza-calendar' + (isScaduto(documento) ? ' scaduto' : '')"
                    />
                }
            </td>
            <td class="text-center">
                <span class="p-column-title">Alert</span>
                <div class="table-actions">                    
                    <i [ngClass]="{'text-green-600': documento.stato == 'accettato'}" class="bi bi-circle-fill lg:text-3xl text-2xl text-green-100 hover:text-green-600 cursor-pointer" (click)="onStato('accettato', documento)"></i>
                    <i [ngClass]="{'text-yellow-600': documento.stato == 'ok'}" class="bi bi-circle-fill lg:text-3xl text-2xl text-yellow-100 hover:text-yellow-400 cursor-pointer" (click)="onStato('ok', documento)"></i>
                    <i [ngClass]="{'text-red-600': documento.stato == 'non accettato'}" class="bi bi-circle-fill lg:text-3xl text-2xl text-red-100 hover:text-red-600 cursor-pointer" (click)="onStato('non accettato', documento)"></i>
                </div>
            </td>
            <td class="text-center">
                <span class="p-column-title">Azioni</span>
                <div class="table-actions">
                    <i class="bi bi-trash" (click)="onOpenDelete($event, documento, index)" title="Elimina"></i>
                    <p-confirmpopup #deleteDocumento>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="acc-btn acc-btn-ghost flex-1"  (click)="onClose()">Annulla</button>
                                    <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>                                        
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmpopup>
                </div>
            </td>
        </tr>
    </ng-template>        
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6">Nessun documento trovato.</td>
        </tr>
    </ng-template>
</p-table>

<app-loading-backoffice [visible]="loading"></app-loading-backoffice>
